export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://glacial-hollows-30081.herokuapp.com/api',
  TOKEN_KEY: process.env.TOKEN_KEY,
}